import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

const useAdminRights = () => {
  const ctx = useAppContext();
  const adminQuery: any = useMeaQuery(
    `@result=[SC.${ctx?.model}];
        @result+=[UM].currentuser;
        @result;`,
    "permissionlevels,accesslevel"
  );
  const isAdmin =
    adminQuery?.data?.data?.filter(
      (item: any) =>
        (item.id?.indexOf("SC") > -1 && item.accesslevel === "Administrate") ||
        (item.id?.indexOf("UM") && item.permissionlevels?.indexOf("SC=2") > -1)
    ).length > 0;
  return isAdmin;
};

export default useAdminRights;
